export default "__VITE_ASSET__8d4ee8fe__"